import React from 'react';
import cx from 'classnames';

import Container from '../container';

import styles from './style.module.scss';

export default (props) => {
  return (
    <div className={styles.purpleDarkNoiseBg}>
      <div className={styles.scallopedEdge} />

      <Container className="u-padding-V-xl">
        <div className="d-flex flex-column-reverse flex-lg-row gap-l">
          <div className={cx(styles.magooshOrigin, 'text-inter')} style={{ color: '#C8BDD6' }}>
            <span style={{ color: '#FFFFFF' }}><strong>Magoosh</strong></span> is a play on the Old Persian word magush, one who is highly learned, wise and generous.
          </div>

          <div className="d-flex flex-wrap flex-lg-nowrap" style={{ rowGap: 30 }}>
            <div className={styles.linkList}>
              <ul>
                <li>Magoosh GRE</li>
                <li><a href="/">Home</a></li>
                <li><a href="/terms">Terms of Use</a></li>
                <li><a href="/sms_terms">SMS Terms</a></li>
                <li><a href="/privacy">Privacy</a></li>
              </ul>
            </div>

            <div className={styles.linkList}>
              <ul>
                <li>Account</li>
                <li><a href="/plans">Plans & Pricing</a></li>
                <li><a href="/login">Login</a></li>
                <li><a href="/forgot_password">Forgot Password</a></li>
              </ul>
            </div>

            <div className={styles.linkList}>
              <ul>
                <li>Company</li>
                <li><a href="https://magoosh.com">Company Home</a></li>
                <li><a href="https://magoosh.com/about">About Us</a></li>
                <li><a href="https://magoosh.com/partner-with-us">Partner With Us</a></li>
                <li><a href="mailto:help@magoosh.com">help@magoosh.com</a></li>
              </ul>
            </div>

            <div className={styles.linkList}>
              <ul>
                <li>Follow Us</li>
                <li><a href="http://www.youtube.com/user/MagooshGRE">YouTube</a></li>
                <li><a href="https://magoosh.com/gre">Blog</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column flex-lg-row gap-m u-margin-T-l">
          <div className="flex-1 text-inter" style={{ color: '#C8BDD6', fontSize: 12 }}>
            © 2025 Magoosh
          </div>

          <div className="text-inter" style={{ color: '#C8BDD6', fontSize: 12 }}>
            GRE® is a registered trademark of Educational Testing Service (ETS). This website is not endorsed or approved by ETS.
          </div>
        </div>
      </Container>
    </div>
  );
};
